import moment from 'moment-timezone';

/**
 * Generate Invoice / Receipt number in a pattern like: 'INV-S1-MYSITE-2301-01' or 'INV-MYSITE-2301-01' depending on the date of the invoice / receipt and operation_status
 * if the invoice / receipt is 2022 or before, the number will be the pattern 'INV-MYSITE-2201-01'
 * if the invoice / receipt is after 2022, the number will be the pattern 'INV-S1-MYSITE-2301-01'
 * if the invoice / receipt is after 2022 and is MSA, the number will be the pattern 'INV-TH-MYSITE-2301-01'
 * @param {Object} param data to build invoice/receipt number
 * @param {String} param.type type of number can only be 'INV' or 'REC' or 'BD'
 * @param {String} param.solarEntityId entity ID like "S1", "S2", "SS", etc. This will be overrided by "TH" if param.isMSA is true
 * @param {String} param.siteCode site code
 * @param {String} param.date date string for this invoice/receipt in a pattern that can be passed in moment.js
 * @param {String} param.DocNo only required if param.type = "REC"
 * @param {Boolean} param.isMSA if this invoice/receipt is for MSA site
 * @param {Boolean} param.isReceiptRef is receipt reference
 * @param {Number} param.clientId client ID for MSA site
 * @returns {String} invoice/receipt number in a pattern "$type-$solarEntityId-$siteCode-YYMM-01"
 */
export function buildInvoiceReceiptNumber({ type, solarEntityId, siteCode, date, docNo="01", isMSA=false, isReceiptRef=false, clientId=null }) {
	type = type?.trim();
	solarEntityId = solarEntityId?.trim();
	solarEntityId = solarEntityId?.replaceAll(/^_OLD_/gi, "");
	siteCode = siteCode?.trim();
	let momentDate = (typeof date === 'string') ? moment(date.trim()) : moment(date);
	if (isMSA && clientId == 379) {
		momentDate = momentDate.clone().add(1, 'month');
	}
	// error checking
	if((type !== 'INV' && type !== 'REC' && type !== 'BD') || (!isMSA && !solarEntityId) || !siteCode || !date || (type === 'REC' && !isReceiptRef && !docNo)) { return 'INVOICE_NUMBER_INVALID' }
	if(!momentDate.isValid()) { return 'INVOICE_DATE_INVALID' }

	// override solarEntityId for MSA site
	if(isMSA) { solarEntityId = "TH" }

	// generate invoice number
	const YYMM = momentDate.format("YYMM");
	const patternAfter2022 		 		= `${type}-${solarEntityId}-${siteCode}-${YYMM}-${docNo}`;
	const patternRefAfter2022 		= `${type}-${solarEntityId}-${siteCode}-${YYMM}`;  // receipt ref for counting running number in ReceiptForm.js
	const pattern2022AndBefore 		= `${type}-${siteCode}-${YYMM}-${docNo}`;
	const patternRef2022AndBefore = `${type}-${siteCode}-${YYMM}`;  // receipt ref for counting running number in ReceiptForm.js
	const endOf2022 = moment('2022-12-01').endOf('month');
	// 2022 and before
	if(momentDate.valueOf() <= endOf2022.valueOf() && !isReceiptRef) {
		return pattern2022AndBefore;
	}
	// 2022 and before (receipt ref only)
	if(momentDate.valueOf() <= endOf2022.valueOf() && isReceiptRef) {
		return patternRef2022AndBefore;
	}
	// 2023 and after
	if(momentDate.valueOf() > endOf2022.valueOf() && !isReceiptRef) {
		return patternAfter2022;
	}
	// 2023 and after (receipt ref only)
	if(momentDate.valueOf() > endOf2022.valueOf() && isReceiptRef) {
		return patternRefAfter2022;
	}
}

export const oldEntityFilter = entity => !/^_OLD_/gi.test(entity.value);
export const formatOldEntityId = entityId => entityId?.replaceAll(/^_OLD_/gi, "");
export const allEntityOpt = { value: '_ALL', label: 'All Entities' };
export const allOpt = { value: '_ALL', label: 'All' };